import { useParams } from 'react-router-dom';

import { useGetProductStockDetailsByVariationIdQuery } from '@/features/slice/inventory';

export const useStockDetails = () => {
    const params = useParams();

    const productVariationId = params['product_variation_id'];

    const { data, isLoading, isError, isFetching, error } =
        useGetProductStockDetailsByVariationIdQuery(productVariationId!);

    return {
        productVariationId,

        data,
        isLoading,
        isError,
        isFetching,
        error,
    };
};
